if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;

        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('active');
        });

        const activeMedia = mediaId ? this.querySelector('[data-media-id="' + mediaId + '"]') : null;
        if (activeMedia) {
          activeMedia.classList.add('active');
        }

        const container = this.querySelector('[role="document"]');
        if (!container) return;

        // Mobile: horizontal scroll to clicked image
        if (window.innerWidth <= 749 && activeMedia) {
          requestAnimationFrame(() => {
            const items = Array.from(container.querySelectorAll('[data-media-id]'));
            const idx = items.indexOf(activeMedia);
            if (idx >= 0) {
              container.scrollLeft = idx * container.clientWidth;
            }
          });
        } else if (activeMedia) {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    }
  );
}